import React, { createContext, useEffect, useState } from 'react';

type GlobalStateContextProps = {
  isCookieEnabled: boolean;
  setCookieEnabled: (value: boolean) => void;
  language: string;
  setLanguage: (value: string) => void;
};

const GlobalStateContext = createContext<GlobalStateContextProps>({
  isCookieEnabled: false,
  setCookieEnabled: () => {},
  language: 'en',
  setLanguage: () => {},
});

interface GlobalStateProviderProps { children?: React.ReactNode }

export const GlobalStateProvider: React.FC<GlobalStateProviderProps> = ({ children }) => {
  const [cookies, setCookies] = useState(false);
  const [language, setLanguageState] = useState('en');
  const supportedLanguages = ['en','es','fr','de','it','pt','nl','pl','ru','zh','ja','ko','ar','th','vi'];

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // 1) Read from URL path prefix: /, /pt, /es, ...
    const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
    const pathLang = supportedLanguages.includes(firstSegment) ? firstSegment : 'en';
    setLanguageState(pathLang);
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', language || 'en');
    }
  }, [language]);

  const setCookieEnabled = (value: boolean) => setCookies(value);
  const setLanguage = (value: string) => {
    setLanguageState(value);
  };

  const value: GlobalStateContextProps = {
    isCookieEnabled: cookies,
    setCookieEnabled,
    language,
    setLanguage,
  };

  return <GlobalStateContext.Provider value={value}>{children}</GlobalStateContext.Provider>;
};

export default GlobalStateContext;


